webpackJsonp([119],{

/***/ 2648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColumnChart_vue__ = __webpack_require__(2920);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1b0a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColumnChart_vue__ = __webpack_require__(3113);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColumnChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1b0a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColumnChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/charts/ColumnChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b1b0a5e", Component.options)
  } else {
    hotAPI.reload("data-v-1b1b0a5e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_vue__ = __webpack_require__(2483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_patientServices__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_selfEvaluationTest_mixin__ = __webpack_require__(2449);
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_selfEvaluationTest_mixin__["a" /* default */]],
    components: {
        'highcharts': __WEBPACK_IMPORTED_MODULE_0_highcharts_vue__["Chart"]
    },
    props: {
        lastYearResults: {
            type: Array,
            required: true
        },
        testName: {
            type: String,
            required: true
        },
        customChart: {
            type: Object,
            required: false
        },
        percentages: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        chartOptions: function chartOptions() {
            var _this2 = this;

            var _this = this;
            var months = [];
            // si se quisiese añadir los meses intermedios que no se rellenan sólo habría que eliminar la lista months y en lugar de (name: month) poner (x: month) En el xAxis recuperar el type datetime con el tickInterval

            var result = this.lastYearResults.map(function (item) {
                var day = new Date(item.date);
                var month = Date.UTC(day.getFullYear(), day.getMonth());
                months.push(Object(__WEBPACK_IMPORTED_MODULE_2__helpers_date_helpers__["e" /* formatDateByMonth */])(day));
                return {
                    name: month,
                    y: _this2.percentages ? item.percentage : item.generalResult,
                    date: day,
                    color: _this2.testName === _this2.$t('tests.mediterranean-diet.title') ? item.generalResult >= 8 ? __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__["g" /* GREEN_COLOUR */] : __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__["k" /* RED_COLOUR */] : _this2.testName === _this2.$t('tests.physical-activity.title') ? _this2.testResultsInfo(__WEBPACK_IMPORTED_MODULE_3__constants_patientServices__["s" /* TEST_PHYSICAL_ACTIVITY */], item.percentage).color : __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__["c" /* BLUE_COLOUR */]
                };
            });

            return {
                chart: {
                    type: 'column',
                    backgroundColor: __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__["a" /* BACKGROUND_COLOUR */],
                    height: this.$uiHelpers.isMobile ? '50%' : this.$uiHelpers.isTablet ? '35%' : '200',
                    width: this.$uiHelpers.isMobile || this.$uiHelpers.isTablet ? null : result.length <= 3 ? result.length * 195 : result.length <= 6 ? result.length * 140 : null
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                tooltip: this.customChart && this.customChart.tooltip ? this.customChart.tooltip : {
                    formatter: function formatter() {
                        return '<b>' + Object(__WEBPACK_IMPORTED_MODULE_2__helpers_date_helpers__["f" /* formatDateByMonthLong */])(this.point.date).replace(/^\w/, function (c) {
                            return c.toUpperCase();
                        }) + '</b><br>\n                                ' + _this.testName + ': <b>' + this.point.y + '%</b>';
                    }
                },
                xAxis: {
                    type: 'category',
                    categories: months,
                    // type: 'datetime',
                    // tickInterval: 31 * 24 * 3600 * 1000,
                    // tickLength: 0,
                    labels: {
                        formatter: function formatter() {
                            return this.value === Object(__WEBPACK_IMPORTED_MODULE_2__helpers_date_helpers__["e" /* formatDateByMonth */])(new Date()) ? '<span style="color: ' + __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__["c" /* BLUE_COLOUR */] + ';"><b> ' + this.value + ' </b></span>' : this.value;
                        }
                    }
                },
                yAxis: this.customChart && this.customChart.yAxis ? this.customChart.yAxis : {
                    title: null,
                    tickInterval: 25,
                    max: 100,
                    gridLineWidth: 0.4,
                    gridLineColor: __WEBPACK_IMPORTED_MODULE_1__constants_colours_js__["f" /* GRAY_COLOUR */]
                },
                series: [{
                    data: result
                }],
                plotOptions: {
                    column: {
                        borderWidth: 0,
                        showInLegend: false,
                        pointWidth: this.$uiHelpers.isMobile ? 10 : this.$uiHelpers.isTablet ? 20 : 50
                        // cursor: 'pointer',
                        // point: {
                        //     events: {
                        //         click: function () {
                        //             _this.$store.commit('tests/setDBResult', _this.$store.state.tests.previousTestResults[1])
                        //         }
                        //     }
                        // }
                    }
                }
            };
        }
    }
});

/***/ }),

/***/ 3113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("highcharts", { attrs: { options: _vm.chartOptions } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b1b0a5e", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/119.4b665085434bf1ee8939.js